<template>
    <!-- maincss Save Design Modal -->

    <div
        class="modal login-form-popup fade h-auto"
        id="savedesign"
        tabindex="-1"
        aria-labelledby="savedesign"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
    >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-body">
                    <a
                        href="#"
                        class="popup-close"
                        id="popup-close"
                        data-dismiss="modal"
                    >
                        <img src="/maincss/images/cancel.svg" alt=" " />
                    </a>
                    <div class="login-form">
                        <h3>Design Title</h3>
                        <p>Please enter the Design title</p>
                        <form
                            method="post"
                            data-vv-scope="loginform"
                            :key="'loginform'"
                        >
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    name="title"
                                    required
                                    id="design_name"
                                    :value="design_name"
                                />
                                <label>Title</label>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <span
                                    id="design_name_error"
                                    class="form-text text-error text-left"
                                    style="display: none"
                                    >Please enter design name.</span
                                >
                            </div>
                            <div class="containt_loader" v-show="isLoader">
                                <div class="preloader-body">
                                    <svg
                                        width="40"
                                        height="40"
                                        viewBox="0 0 40 40"
                                    >
                                        <polygon
                                            class="rect"
                                            points="0 0 0 40 40 40 40 0"
                                        ></polygon>
                                    </svg>
                                </div>
                            </div>

                            <button
                                type="button"
                                @click="save_all_design()"
                                class="btn btn_orange bg_primary_orange text_white w-100 mt_34 mb_32 btn_h60"
                            >
                                CONTINUE
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { LOGIN, REGISTER, LOGOUT } from "@/store/actions.type";
import ApiService from "@/common/api.service";
import html2canvas from "html2canvas";

export default {
    data() {
        return {
            design_name: "",
            dataURL: "",
            user_selected_values: [],
            product_id: "",
            product_items: [],
            isLoader: false,
            login_data: [
                {
                    email: null,
                    password: null
                }
            ],
            registration_data: [
                {
                    first_name: null,
                    last_name: null,
                    email: null,
                    password: null,
                    confirm_password: null,
                    accept_terms: null
                }
            ],
            resetform_data: [
                {
                    email: null
                }
            ],
            redirect_path: "/myorder"
        };
    },
    mounted() {
        var _this = this;
        /* eslint-disable */
        $(document).on("hide.bs.modal", "#login", function () {
            _this.$validator.reset();
            _this.login_data = [
                {
                    email: null,
                    password: null
                }
            ];
            //Do stuff here
        });
        $(document).on("click", ".login-cart", function () {
            console.log($(this).data("path"));
            _this.redirect_path = $(this).data("path");
        });
        /* eslint-enable */
    },
    methods: {
        save_all_design() {
            //add and update product
            var _this = this;
            _this.isLoader = true;
            _this.product_id = localStorage.getItem("product_id");
            _this.product_items = localStorage.getItem("product_items");
            _this.user_selected_values = JSON.parse(
                localStorage.getItem("user_selected_values")
            );

            document.querySelector("span#design_name_error").style.display =
                "none";
            if (document.querySelector("input#design_name").value != "") {
                let div = document.getElementById("shirtDiv");
                html2canvas(div)
                    .then((canvas) => {
                        var _this = this;
                        _this.dataURL = canvas.toDataURL("image/png");
                    })
                    .catch(() => {});
                _this.design_name =
                    document.querySelector("input#design_name").value;

                setTimeout(function () {
                    var canvas_details = [];
                    canvas_details.push(
                        {
                            canvas: localStorage.getItem("canvas_elements")
                                ? JSON.parse(
                                      localStorage.getItem("canvas_elements")
                                  )
                                : ""
                        },
                        { product_details: _this.product_items },
                        { gender_values: _this.user_selected_values },
                        { design_name: _this.design_name },
                        { designImage: _this.dataURL },
                        { id: _this.product_id }
                    );
                    if (localStorage.getItem("canvas_elements")) {
                        new Promise(() => {
                            ApiService.post(
                                "/add-designstudio-Product",
                                canvas_details
                            ).then(({ data }) => {
                                console.log(data.success);
                                if (data.success == true) {
                                    /* eslint-disable */
                                    $("#savedesign").modal("hide");
                                    /* eslint-enable */
                                    _this.$toast.success(
                                        "Product saved successfully",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                    localStorage.removeItem("canvas_elements");
                                    localStorage.removeItem("active_gender");
                                    localStorage.removeItem(
                                        "active_gender_key"
                                    );
                                    localStorage.removeItem("active_flip");
                                    localStorage.removeItem("category_object");
                                    localStorage.removeItem("type");
                                    localStorage.removeItem("index");
                                    localStorage.removeItem("design");
                                    // window.location.href = "/myaccount";
                                    _this.$router.push({ name: "MyAccount" });
                                    _this.isLoader = false;
                                } else {
                                    _this.$toast.error(
                                        "Please design your T-shirt",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                }
                            });
                        });
                    } else {
                        _this.$toast.error("Please design your T-shirt", {
                            position: "top-right"
                        });
                        _this.isLoader = false;
                    }
                }, 1000);
            } else {
                document.querySelector("span#design_name_error").style.display =
                    "block";
                setTimeout(function () {
                    document.querySelector(
                        "span#design_name_error"
                    ).style.display = "none";
                }, 1000);
            }
        },
        logout() {
            this.$store.dispatch(LOGOUT).then(() => {
                this.$router.push({ path: "/" });
            });
        },
        onSubmitToLogin() {
            var _this = this;

            _this.$validator.validateAll("loginform").then((isValid) => {
                if (isValid) {
                    _this.$store
                        .dispatch(LOGIN, {
                            email: _this.login_data.email,
                            password: _this.login_data.password
                        })
                        .then((response) => {
                            if (response.success) {
                                _this.$toast.success("Login Successfully.", {
                                    position: "top-right"
                                });
                                document.getElementById("popup-close").click();
                                _this.$root.$emit("update-cart");
                                _this.syncCart();
                                this.$router.push({
                                    path: _this.redirect_path
                                });
                            } else {
                                let field =
                                    response.error == "Invalid password"
                                        ? "password"
                                        : "email";
                                _this.errors.itemslength = 0;
                                _this.errors.items.push({
                                    id: 1,
                                    vmId: _this.errors.vmId,
                                    field: field,
                                    msg: response.error,
                                    scope: "loginform"
                                });
                                console.log("login error", _this.errors);
                            }
                        });
                } else {
                    console.log("gjhghj", _this.errors);
                }
            });
        },
        syncCart() {
            var _this = this;
            if (localStorage.getItem("cart")) {
                let cart = JSON.parse(localStorage.getItem("cart"));
                new Promise(() => {
                    let post_data = {
                        items: cart.items,
                        totalQty: cart.totalQty,
                        totalPrice: cart.totalPrice
                    };
                    ApiService.setHeader();
                    // console.log(cart.items,post_data);
                    ApiService.post("/sync-cart", post_data)
                        .then(({ data }) => {
                            console.log(data);
                        })
                        .catch(({ response }) => {
                            console.log(response);
                        });
                });
            }

            console.log(_this.cart_items);
        },
        onSubmitToRegister() {
            this.$validator.validateAll("signupform").then((isValid) => {
                if (isValid) {
                    this.$store
                        .dispatch(REGISTER, {
                            first_name: this.registration_data.first_name,
                            last_name: this.registration_data.last_name,
                            email: this.registration_data.email,
                            password: this.registration_data.password,
                            confirm_password:
                                this.registration_data.confirm_password
                        })
                        .then((response) => {
                            console.log(response);
                            /* eslint-disable */
                            _this.$toast.success(
                                "User registered Successfully.",
                                {
                                    position: "top-right"
                                }
                            );
                            $("#register").modal("hide");
                            /* eslint-enable */
                            this.$router.push({ path: "/" });
                        });
                } else {
                    console.log("gjhghj", this.errors);
                }
            });
        },
        onSubmitToResetPassword() {
            this.$validator.validateAll("signupform").then((isValid) => {
                if (isValid) {
                    this.$store
                        .dispatch(REGISTER, {
                            email: this.registration_data.email
                        })
                        .then((response) => {
                            console.log(response);
                            /* eslint-disable */
                            $("#register").modal("hide");
                            /* eslint-enable */
                            this.$router.push({ path: "/" });
                        });
                } else {
                    console.log("gjhghj", this.errors);
                }
            });
        }
    }
};
</script>
